/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_New_York_PostInputs */

const en_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const de_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const pt_br2_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const tr_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const zh_cn2_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const zh_hk2_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const ko_kr2_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const ru_ru2_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

const es_419_onboarding_v1_press_new_york_post = /** @type {(inputs: Onboarding_V1_Press_New_York_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New York Post`)
};

/**
* | output |
* | --- |
* | "New York Post" |
*
* @param {Onboarding_V1_Press_New_York_PostInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_new_york_post = /** @type {((inputs?: Onboarding_V1_Press_New_York_PostInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_New_York_PostInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_new_york_post(inputs)
	if (locale === "de") return de_onboarding_v1_press_new_york_post(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_new_york_post(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_new_york_post(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_new_york_post(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_new_york_post(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_new_york_post(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_new_york_post(inputs)
	return es_419_onboarding_v1_press_new_york_post(inputs)
});